export const mercafacilThemeColors = {
  primary: '#002040',
  secondary: '#adb5bd',
  ativos: '#53D800',
  inativos: '#F03E3E',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',

  branco: '#FFFFFF',
  preto: '#000000',

  'marca-0': '#002040',
  'marca-0-d10': '#001D3A',
  'marca-0-l10': '#00366D',
  'marca-0-l20': '#004D99',
  'marca-0-l30': '#0063C6',
  'marca-0-l40': '#0079F2',
  'marca-0-l90': '#D2E9FF',

  'marca-1': '#00B395',
  'marca-1-d30': '#007D68',
  'marca-1-d20': '#008F77',
  'marca-1-d10': '#00A186',
  'marca-1-l10': '#01D5B1',
  'marca-1-l20': '#01F5CD',

  'marca-2': '#D4FF01',
  'marca-2-d30': '#94B300',
  'marca-2-d20': '#AACC01',
  'marca-2-d10': '#BFE600',
  'marca-2-l10': '#D8FF1B',

  'cinza-0': '#6B7580',
  'cinza-d20': '#31363B',
  'cinza-d10': '#4B525A',
  'cinza-l10': '#78838E',
  'cinza-l20': '#87919B',
  'cinza-l30': '#969EA7',
  'cinza-l40': '#A5ACB5',
  'cinza-l50': '#B4BAC0',
  'cinza-l60': '#C3C8CD',
  'cinza-l70': '#D2D6D9',
  'cinza-l80': '#ECEDF0',
  'cinza-l90': '#F6F6F8',

  'vermelho-0': '#E03211',
  'vermelho-d20': '#B3280D',
  'vermelho-l20': '#F15435',
  'vermelho-l40': '#F47F69',

  'verde-0': '#0A8533',
  'verde-d20': '#086A2A',
  'verde-l10': '#0DA740',
  'verde-l20': '#0FC94D',

  'laranja-0': '#F2803F',
  'laranja-d20': '#C65718',

  'ilustracao-solid-1': '#17A08A',
  'ilustracao-solid-2': '#00B395',
  'ilustracao-solid-3': '#C9EAE3',
  'ilustracao-solid-4': '#BAEBCE',
  'ilustracao-solid-5': '#E6F8E8',
  'ilustracao-solid-6': '#F5FBF9',
}
